/* eslint-disable react/no-danger */
import React from 'react';

import { config } from '../../config';

export const CookieComplianceProvider: React.FC<{ lang: string }> = ({ lang }) => {
  const prefix = lang.toUpperCase();

  return (
    // noinspection HtmlRequiredTitleElement
    <>
      <link rel="stylesheet" href="/static/cookie/assets/ct-ultimate-gdpr.min.css" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css" />

      <script type="text/javascript" src="/static/cookie/assets/ct-ultimate-gdpr.min.js" />
      <script type="text/javascript" src={`/static/cookie/assets/init_${prefix}.js`} />
    </>
  );
};

export const CryptoSDKLoader: React.FC = () => (
  <script src={`https://js.crypto.com/sdk?publishable-key=${config.crpyto.publishable}`} />
);
